/* Blog index (sections/main-blog.liquid): robot filter in place (?robot=handle), Load more 9 at a time,
   Hide filters (remembered), and the quiz and sign-up tiles kept after the 6th visible card. */
if (!customElements.get('blog-filters')) {
  const STEP = 9;
  const KEY = 'bb-blog-filters-hidden';

  class BlogFilters extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-blog]');
      this.grid = this.root.querySelector('[data-grid]');
      this.cards = [...this.grid.querySelectorAll('[data-card]')];
      this.tiles = this.grid.querySelector('[data-tiles]');
      this.more = this.root.querySelector('[data-more]');
      this.shown = STEP;
      this.robot = new URLSearchParams(location.search).get('robot') || '';

      const toggle = this.querySelector('[data-toggle]');
      let hidden = false;
      try { hidden = localStorage.getItem(KEY) === '1'; } catch (e) {}
      this.setCollapsed(hidden, toggle);
      toggle.addEventListener('click', () => {
        const next = !this.classList.contains('is-collapsed');
        this.setCollapsed(next, toggle);
        try { localStorage.setItem(KEY, next ? '1' : '0'); } catch (e) {}
      });

      this.querySelectorAll('[data-robot]').forEach((chip) => {
        chip.addEventListener('click', (event) => {
          event.preventDefault();
          this.robot = chip.dataset.robot;
          this.shown = STEP;
          const url = new URL(location.href);
          if (this.robot) url.searchParams.set('robot', this.robot); else url.searchParams.delete('robot');
          history.replaceState(null, '', url);
          this.render();
        });
      });
      this.more.querySelector('[data-load]').addEventListener('click', () => { this.shown += STEP; this.render(); });
      this.render();
    }

    setCollapsed(collapsed, toggle) {
      this.classList.toggle('is-collapsed', collapsed);
      toggle.setAttribute('aria-expanded', String(!collapsed));
      toggle.textContent = collapsed ? toggle.dataset.showLabel : toggle.dataset.hideLabel;
    }

    render() {
      const matches = this.cards.filter((card) => !this.robot || card.dataset.robots.split(' ').includes(this.robot));
      this.cards.forEach((card) => card.classList.add('is-hidden'));
      matches.slice(0, this.shown).forEach((card) => card.classList.remove('is-hidden'));

      this.querySelectorAll('[data-robot]').forEach((chip) => chip.classList.toggle('is-on', chip.dataset.robot === this.robot));
      const clear = this.querySelector('[data-clear]');
      if (clear) clear.hidden = !this.robot;

      const count = this.querySelector('[data-count]');
      const total = matches.length;
      count.textContent = count.textContent.replace(/\d+/, total).replace(/guides?$/, total === 1 ? 'guide' : 'guides');

      // Quiz and sign-up tiles sit after the 6th visible card, or after the last one when fewer show
      const visible = matches.slice(0, this.shown);
      if (this.tiles) {
        const anchor = visible[Math.min(5, visible.length - 1)];
        if (anchor) anchor.after(this.tiles);
        this.tiles.hidden = visible.length === 0;
      }
      this.grid.querySelector('[data-empty]').hidden = total > 0;

      this.more.hidden = total <= this.shown;
      const showing = this.more.querySelector('[data-showing]');
      showing.textContent = showing.dataset.template.replace('[shown]', Math.min(this.shown, total)).replace('[total]', total);
      this.more.querySelector('[data-bar]').style.width = `${Math.min(100, (this.shown / Math.max(total, 1)) * 100)}%`;
    }
  }
  customElements.define('blog-filters', BlogFilters);
}
